import { render, staticRenderFns } from "./alert-success.vue?vue&type=template&id=6f030dab&scoped=true"
import script from "./alert-success.vue?vue&type=script&lang=js"
export * from "./alert-success.vue?vue&type=script&lang=js"
import style0 from "./alert-success.vue?vue&type=style&index=0&id=6f030dab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f030dab",
  null
  
)

export default component.exports